



















































module.exports =
  name: 'total_stats'
  components:
    balance: require('components/inside/elements/balance.vue').default
  props: ['transactions']
  data: -> { display_tooltip: false }
  computed:
    incomes:  -> @transactions.filter (tr) -> tr.subtype == 'i'
    expenses: -> @transactions.filter (tr) -> tr.subtype == 'e'
    stats: ->
      incomes_sum = @$store.getters.transactions_sum @incomes
      expenses_sum = @$store.getters.transactions_sum(@expenses)
      savings_rate = 100 + _.round(expenses_sum / incomes_sum * 100)
      savings_rate = 0 unless _.isFinite(savings_rate)

      plan_incomes_sum = @$store.getters.transactions_plan_sum @incomes
      plan_expenses_sum = @$store.getters.transactions_plan_sum(@expenses)
      return
        incomes       : incomes_sum
        expenses      : expenses_sum
        net           : incomes_sum + expenses_sum
        savings_rate  : savings_rate
        plan_incomes  : plan_incomes_sum
        plan_expenses : plan_expenses_sum
        plan_net      : plan_incomes_sum + plan_expenses_sum
  methods:
    showTooltip: ->
      @display_tooltip = true
      @$nextTick =>
        @tooltip = $(@$el).find('.el-tooltip__popper').show()
        if @tooltip.length
          @popper = new Popper($(@$el), @tooltip, { placement: 'left' })
    hideTooltip: ->
      @display_tooltip = false
      @tooltip.hide() if @tooltip
      @popper.destroy() if @popper
